import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import { useStore } from "vuex";
  import { onMounted, ref, watch } from "vue";
  import { formatDate } from "@/helpers/date";
  import { StageStatus } from "@/enums/StageStatus";
  import { getDocumentName } from "@/helpers/documents";

  type StageSummary = {
    _id: string;
    title: string;
    status: string;
  };

  type MapStage = {
    stageId: StageSummary;
  };

  type StageDocument = {
    fileName: string;
    modifiedDate: string;
    url: string;
    ETag?: string;
    eTag?: string;
    deleteDate?: string | null;
    deletedAt?: string | null;
    deleted?: boolean;
    isDeleted?: boolean;
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StageDocumentsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    estateId: {
      type: String,
      default: "",
    },
    stageId: {
      type: String,
      default: "",
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const emits = __emit;

  const props = __props;

  const loadingStages = ref(false);
  const loadingDocs = ref(false);
  const stages = ref<StageSummary[]>([]);
  const stageDocs = ref<StageDocument[]>([]);
  const selectedStageId = ref<string>("");

  onMounted(() => {
    if (props.isOpen) {
      if (props.stageId) {
        loadStageDocs(props.stageId);
      } else {
        loadStages();
      }
    }
  });

  watch(
    () => props.isOpen,
    (val) => {
      if (val) {
        if (props.stageId) {
          loadStageDocs(props.stageId);
        } else {
          loadStages();
        }
      }
    }
  );

  const loadStages = () => {
    loadingStages.value = true;
    store
      .dispatch("stage/getStagesMap", {
        estateId: props.estateId,
        isCustomer: true,
      })
      .then((res) => {
        const mapsStages: MapStage[] = res.data;

        stages.value = mapsStages
          .map((ms) => ms.stageId)
          .filter(
            (s) =>
              s.status === StageStatus.NOW_SELLING ||
              s.status === StageStatus.SOLD_OUT
          );

        if (stages.value.length > 0) {
          selectStage(stages.value[0]._id);
        }
      })
      .finally(() => {
        loadingStages.value = false;
      });
  };

  const selectStage = (stageId: string) => {
    selectedStageId.value = stageId;
    loadStageDocs(stageId);
  };

  const loadStageDocs = (stageId: string) => {
    loadingDocs.value = true;
    stageDocs.value = [];
    store
      .dispatch("stage/getStageDocuments", stageId)
      .then((res) => {
        stageDocs.value = getVisibleDocuments(res.data);
      })
      .finally(() => {
        loadingDocs.value = false;
      });
  };

  const openDoc = (doc: StageDocument) => {
    window.open(doc.url, "_blank", "noopener,noreferrer");
  };

  const getVisibleDocuments = (documents: unknown) => {
    if (!Array.isArray(documents)) {
      return [];
    }

    const documentKeys = new Set<string>();

    return (documents as StageDocument[]).filter((document) => {
      if (isSoftDeleted(document)) {
        return false;
      }

      const documentKey =
        document.ETag ??
        document.eTag ??
        `${document.fileName}:${document.url}`;

      if (documentKeys.has(documentKey)) {
        return false;
      }

      documentKeys.add(documentKey);
      return true;
    });
  };

  const isSoftDeleted = (document: StageDocument) =>
    document.deleted === true ||
    document.isDeleted === true ||
    Boolean(document.deleteDate || document.deletedAt);

const __returned__ = { store, emits, props, loadingStages, loadingDocs, stages, stageDocs, selectedStageId, loadStages, selectStage, loadStageDocs, openDoc, getVisibleDocuments, isSoftDeleted, Modal, get useStore() { return useStore }, onMounted, ref, watch, get formatDate() { return formatDate }, get StageStatus() { return StageStatus }, get getDocumentName() { return getDocumentName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})